(function () {
  var cfg = window.KAMELY_CHECKOUT;
  if (!cfg || !cfg.apiBase || !cfg.storeSlug) return;

  var PENDING_KEY = 'kamely_shopify_pending_session';
  var TRACKING_KEY = 'kamely_shopify_url_params';
  var SKIP_QUERY_KEYS = { kamely_paid: 1, kamely_session: 1 };
  var SCRIPT_VERSION = '2.4.0-zedy-block';
  var skipCartEnabled = cfg.skipCart === true || cfg.skipCart === 'true' || cfg.skipCart === 1;
  var skipCartInFlight = false;
  var cartTakeoverStarted = false;

  function isCartPage() {
    return /(^|\/)cart\/?$/.test(window.location.pathname || '');
  }

  function isBlockedCheckoutUrl(url) {
    return /zedy\.com\.br/i.test(String(url || ''));
  }

  function neutralizeForeignCheckout() {
    try {
      window.chtCheckoutUrl = '';
      window.fakeClick = function (e) { if (e && e.preventDefault) e.preventDefault(); };
      window.yampiClick = function () { return false; };
    } catch (e) {}
  }

  function patchNetworkGuards() {
    if (window.__kamelyNetGuard) return;
    window.__kamelyNetGuard = true;
    try {
      var open = XMLHttpRequest.prototype.open;
      var send = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) {
        this.__kamelyUrl = url;
        return open.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function () {
        if (isBlockedCheckoutUrl(this.__kamelyUrl)) {
          try { this.abort(); } catch (e) {}
          return;
        }
        return send.apply(this, arguments);
      };
    } catch (e) {}
    try {
      var origFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (isBlockedCheckoutUrl(url)) {
          return Promise.resolve(new Response('{}', { status: 204 }));
        }
        return origFetch.apply(this, arguments);
      };
    } catch (e) {}
  }

  patchNetworkGuards();
  neutralizeForeignCheckout();

  function apiBase() {
    var base = String(cfg.apiBase);
    if (base.charAt(base.length - 1) === '/') base = base.slice(0, -1);
    return base;
  }

  function apiUrl(trackingParams) {
    var base = apiBase() + '/lke/' + encodeURIComponent(cfg.storeSlug) + '/shopify-cart';
    if (!trackingParams || !Object.keys(trackingParams).length) return base;
    try {
      var u = new URL(base);
      Object.keys(trackingParams).forEach(function (k) {
        if (SKIP_QUERY_KEYS[k]) return;
        if (trackingParams[k] != null && trackingParams[k] !== '') {
          u.searchParams.set(k, trackingParams[k]);
        }
      });
      return u.toString();
    } catch (e) {
      return base;
    }
  }

  /** Garante tracking na URL do checkout mesmo se a API só devolver return_url. */
  function buildFinalCheckoutUrl(checkoutUrl, trackingParams) {
    if (!checkoutUrl) return checkoutUrl;
    var params = trackingParams || {};
    if (!Object.keys(params).length) return checkoutUrl;
    try {
      var u = new URL(checkoutUrl);
      var returnUrl = u.searchParams.get('return_url');
      u.searchParams.delete('return_url');
      Object.keys(params).forEach(function (k) {
        if (SKIP_QUERY_KEYS[k]) return;
        if (params[k] != null && params[k] !== '') u.searchParams.set(k, params[k]);
      });
      if (returnUrl) u.searchParams.set('return_url', returnUrl);
      return u.toString();
    } catch (e) {
      return appendParamsToUrl(checkoutUrl, params);
    }
  }

  function statusUrl(sessionId) {
    return apiBase() + '/lke/shopify-cart-status/' + encodeURIComponent(sessionId);
  }

  function rememberPendingSession(sessionId) {
    try {
      if (sessionId) localStorage.setItem(PENDING_KEY, String(sessionId));
    } catch (e) {}
  }

  function mergeParams() {
    var out = {};
    for (var i = 0; i < arguments.length; i++) {
      var src = arguments[i];
      if (!src || typeof src !== 'object') continue;
      Object.keys(src).forEach(function (k) {
        if (SKIP_QUERY_KEYS[k]) return;
        if (src[k] != null && src[k] !== '') out[k] = String(src[k]);
      });
    }
    return out;
  }

  function collectPageQueryParams() {
    var params = new URLSearchParams(window.location.search);
    var out = {};
    params.forEach(function (val, key) {
      if (SKIP_QUERY_KEYS[key]) return;
      if (val != null && val !== '') out[key] = val;
    });
    return out;
  }

  function persistTrackingFromPage() {
    var current = collectPageQueryParams();
    if (!Object.keys(current).length) return;
    try {
      var stored = {};
      try { stored = JSON.parse(sessionStorage.getItem(TRACKING_KEY) || '{}'); } catch (e) {}
      sessionStorage.setItem(TRACKING_KEY, JSON.stringify(mergeParams(stored, current)));
    } catch (e) {}
  }

  function getCookie(name) {
    try {
      var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[]\/+^])/g, '\$1') + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : '';
    } catch (e) {
      return '';
    }
  }

  function getAllTrackingParams() {
    var stored = {};
    try { stored = JSON.parse(sessionStorage.getItem(TRACKING_KEY) || '{}'); } catch (e) {}
    var merged = mergeParams(stored, collectPageQueryParams());
    // Cookie TikTok (_ttp) — essencial para atribuição na Events API
    var ttp = getCookie('_ttp');
    if (ttp && !merged.ttp && !merged._ttp) merged.ttp = ttp;
    return merged;
  }

  function appendParamsToUrl(baseUrl, extraParams) {
    if (!baseUrl || !extraParams) return baseUrl;
    var keys = Object.keys(extraParams);
    if (!keys.length) return baseUrl;
    try {
      var u = new URL(baseUrl);
      keys.forEach(function (k) {
        if (SKIP_QUERY_KEYS[k]) return;
        if (extraParams[k] != null && extraParams[k] !== '') {
          u.searchParams.set(k, extraParams[k]);
        }
      });
      return u.toString();
    } catch (e) {
      var sep = baseUrl.indexOf('?') >= 0 ? '&' : '?';
      var qs = new URLSearchParams();
      keys.forEach(function (k) {
        if (SKIP_QUERY_KEYS[k]) return;
        if (extraParams[k] != null && extraParams[k] !== '') qs.set(k, extraParams[k]);
      });
      return baseUrl + sep + qs.toString();
    }
  }

  async function clearShopifyCart() {
    try {
      await fetch('/cart/clear.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
      });
    } catch (e) {
      console.warn('[Kamely Checkout] cart/clear.js', e);
    }
  }

  async function clearCartIfSessionPaid(sessionId) {
    if (!sessionId) return false;
    try {
      var res = await fetch(statusUrl(sessionId), { credentials: 'omit' });
      var json = await res.json().catch(function () { return {}; });
      if (json.success && json.data && json.data.paid) {
        await clearShopifyCart();
        try { localStorage.removeItem(PENDING_KEY); } catch (e) {}
        return true;
      }
    } catch (e) {
      console.warn('[Kamely Checkout] status', e);
    }
    return false;
  }

  async function handleReturnFromCheckout() {
    var params = new URLSearchParams(window.location.search);
    var paid = params.get('kamely_paid');
    var sessionId = params.get('kamely_session');
    if (paid === '1' && sessionId) {
      var cleared = await clearCartIfSessionPaid(sessionId);
      if (cleared) {
        params.delete('kamely_paid');
        params.delete('kamely_session');
        var next = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
        if (window.history && window.history.replaceState) {
          window.history.replaceState({}, '', next);
        }
      }
      return;
    }
    var pending = null;
    try { pending = localStorage.getItem(PENDING_KEY); } catch (e) {}
    if (pending) await clearCartIfSessionPaid(pending);
  }

  /** Envia linhas para a API Kamely e redireciona (ou abre em nova aba) para o checkout */
  async function redirectToKamelyWithLines(lines, openInNewTab) {
    if (!lines || !lines.length) return;
    try {
      var pageParams = getAllTrackingParams();
      var res = await fetch(apiUrl(pageParams), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          lines: lines,
          url_params: pageParams,
          page_url: window.location.href,
          page_search: window.location.search
        })
      });
      var json = await res.json().catch(function () { return {}; });
      var checkoutUrl = json.data && json.data.checkout_url;
      var txId = json.data && json.data.txId;
      if (json.success && checkoutUrl) {
        var serverParams = (json.data && json.data.url_params) || {};
        var allParams = mergeParams(serverParams, pageParams);
        checkoutUrl = buildFinalCheckoutUrl(checkoutUrl, allParams);
        if (txId) rememberPendingSession(txId);
        // window.open depois de await fetch é bloqueado pelo navegador (some o clique).
        // Só tenta nova aba se ainda houver gesto do usuário; senão redireciona na mesma.
        if (openInNewTab) {
          var opened = window.open(checkoutUrl, '_blank');
          if (opened) return;
        }
        window.location.href = checkoutUrl;
        return;
      }
      var msg = (json.errors && json.errors[0] && json.errors[0].message) || json.message || 'Erro ao abrir checkout Kamely.';
      alert(msg);
    } catch (err) {
      console.error('[Kamely Checkout]', err);
      alert(err.message || 'Erro ao iniciar checkout Kamely.');
    }
  }

  async function redirectToKamely(ev) {
    if (ev) {
      ev.preventDefault();
      ev.stopImmediatePropagation();
    }
    try {
      var cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!cartRes.ok) throw new Error('Não foi possível ler o carrinho.');
      var cart = await cartRes.json();
      var lines = (cart.items || []).map(function (item) {
        return { variant_id: item.variant_id, quantity: item.quantity };
      });
      await redirectToKamelyWithLines(lines);
    } catch (err) {
      console.error('[Kamely Checkout]', err);
      alert(err.message || 'Erro ao iniciar checkout Kamely.');
    }
  }


  function closestAddToCartForm(el) {
    if (el && el.closest) {
      var nearby = el.closest('form[action*="/cart/add"]')
        || el.closest('form[data-type="add-to-cart-form"]')
        || el.closest('form.product-form')
        || el.closest('[data-product-form]');
      if (nearby) {
        if (nearby.tagName === 'FORM') return nearby;
        var inner = nearby.querySelector && nearby.querySelector('form');
        if (inner) return inner;
      }
    }
    return document.querySelector('form[action*="/cart/add"]')
      || document.querySelector('form.product-form')
      || document.querySelector('form[data-type="add-to-cart-form"]');
  }

  function isAddToCartTrigger(el) {
    if (!el || !el.closest) return false;
    if (el.closest('[data-action="add-to-cart"]')) return true;
    if (el.closest('.product-form__add-button')) return true;
    if (el.closest('#clicar')) return true;
    if (el.closest('button[name="add"], input[name="add"]')) return true;
    if (el.closest('[name="add"]')) return true;
    if (el.closest('.botaoflutuante')) return true;
    var btn = el.closest('button, input[type="submit"], span.button, a.button');
    if (btn && btn.closest && btn.closest('form[action*="/cart/add"], form.product-form')) {
      var label = String(btn.textContent || btn.value || '');
      if (btn.getAttribute('type') === 'submit' || /comprar/i.test(label)) return true;
    }
    return false;
  }

  function linesFromForm(form) {
    if (!form) return null;
    var variantInput = form.querySelector('[name="id"]') || form.querySelector('[name="variant_id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var variantId = variantInput ? String(variantInput.value).trim() : null;
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    if (!variantId) return null;
    return [{ variant_id: variantId, quantity: qty }];
  }

  /**
   * Skip Cart: intercepta CLICK (Tema Evolution usa data-action="add-to-cart" e
   * cancela o submit) e SUBMIT do form. Sempre redireciona na mesma aba —
   * window.open após fetch é bloqueado e o botão parece "não aplicar o link".
   */
  async function startSkipCartFromForm(form, triggerEl) {
    if (skipCartInFlight) return;
    skipCartInFlight = true;

    var lines = linesFromForm(form);
    var submitBtn = triggerEl && triggerEl.matches && triggerEl.matches('button, input, span, a')
      ? triggerEl
      : (form && form.querySelector('button[type="submit"], input[type="submit"], button[name="add"], [data-action="add-to-cart"]'));
    var originalText = submitBtn ? (submitBtn.textContent || submitBtn.value) : null;
    if (submitBtn) {
      submitBtn.disabled = true;
      if (submitBtn.textContent !== undefined) submitBtn.textContent = '...';
      else submitBtn.value = '...';
    }

    try {
      if (lines) {
        await redirectToKamelyWithLines(lines, false);
      } else {
        console.warn('[Kamely Checkout] skip_cart: variant_id não encontrado no form.');
        await redirectToKamely(null);
      }
    } finally {
      skipCartInFlight = false;
      if (submitBtn) {
        submitBtn.disabled = false;
        if (originalText !== null) {
          if (submitBtn.textContent !== undefined) submitBtn.textContent = originalText;
          else submitBtn.value = originalText;
        }
      }
    }
  }

  function handleSkipCartSubmit(ev) {
    ev.preventDefault();
    ev.stopImmediatePropagation();
    ev.stopPropagation();
    var form = ev.currentTarget && ev.currentTarget.tagName === 'FORM'
      ? ev.currentTarget
      : closestAddToCartForm(ev.target);
    startSkipCartFromForm(form, ev.target);
  }

  function handleSkipCartClick(ev) {
    if (!isAddToCartTrigger(ev.target)) return;
    var form = closestAddToCartForm(ev.target);
    ev.preventDefault();
    ev.stopImmediatePropagation();
    ev.stopPropagation();
    if (!form) {
      console.warn('[Kamely Checkout] skip_cart: form não encontrado, lendo o carrinho.');
      redirectToKamely(null);
      return;
    }
    startSkipCartFromForm(form, ev.target);
  }

  function handleDocumentSubmit(ev) {
    if (!skipCartEnabled) return;
    var form = ev.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = String(form.getAttribute('action') || form.action || '');
    var isAdd = action.indexOf('/cart/add') !== -1
      || (form.classList && form.classList.contains('product-form'));
    if (!isAdd) return;
    handleSkipCartSubmit(ev);
  }

  function patchNativeFormSubmit() {
    if (!skipCartEnabled || HTMLFormElement.prototype.__kamelySubmit) return;
    HTMLFormElement.prototype.__kamelySubmit = true;
    var nativeSubmit = HTMLFormElement.prototype.submit;
    HTMLFormElement.prototype.submit = function () {
      var action = String(this.getAttribute('action') || this.action || '');
      if (action.indexOf('/cart/add') !== -1 || (this.classList && this.classList.contains('product-form'))) {
        startSkipCartFromForm(this, this.querySelector('[type="submit"], [data-action="add-to-cart"]'));
        return;
      }
      return nativeSubmit.apply(this, arguments);
    };
  }

  async function takeoverCartPage() {
    if (!isCartPage() || cartTakeoverStarted) return;
    cartTakeoverStarted = true;
    neutralizeForeignCheckout();
    if (!skipCartEnabled) return;
    try {
      var cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!cartRes.ok) return;
      var cart = await cartRes.json();
      var lines = (cart.items || []).map(function (item) {
        return { variant_id: item.variant_id, quantity: item.quantity };
      });
      if (lines.length) await redirectToKamelyWithLines(lines, false);
    } catch (e) {
      console.warn('[Kamely Checkout] cart takeover', e);
    }
  }

  var CHECKOUT_SELECTORS = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href="/checkout"]',
    'a[href*="/checkouts/"]',
    'a[href*="/checkout"]',
    '.cart__checkout-button',
    '.btn-checkout',
    '.cht_check_mainBtn',
    '#checkout',
    '#CartDrawer-Checkout',
    '[data-cart-checkout]',
    'form[action="/cart"] button[type="submit"]',
    'form[action*="/checkout"] button',
    'form[action*="/checkout"] input[type="submit"]'
  ];

  // Seletores dos FORMULÁRIOS de adicionar ao carrinho (skip_cart)
  var ADD_TO_CART_FORM_SELECTORS = [
    'form[action="/cart/add"]',
    'form[action*="/cart/add"]',
    'form[data-type="add-to-cart-form"]',
    'form.product-form',
    '[data-product-form]'
  ];

  function bindCheckoutButtons() {
    CHECKOUT_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.dataset.kamelyCheckoutBound === '1') return;
        el.dataset.kamelyCheckoutBound = '1';
        el.addEventListener('click', redirectToKamely, true);
      });
    });

    if (skipCartEnabled) {
      ADD_TO_CART_FORM_SELECTORS.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (form) {
          if (form.dataset.kamelySkipCartBound === '1') return;
          form.dataset.kamelySkipCartBound = '1';
          form.addEventListener('submit', handleSkipCartSubmit, true);
        });
      });
    }
  }


  function initKamelyCheckout() {
    try { console.info('[Kamely Checkout]', SCRIPT_VERSION, skipCartEnabled ? '| skip_cart: ON' : ''); } catch (e) {}
    persistTrackingFromPage();
    patchNativeFormSubmit();
    bindCheckoutButtons();
    handleReturnFromCheckout();
    takeoverCartPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKamelyCheckout);
  } else {
    initKamelyCheckout();
  }
  document.addEventListener('cart:updated', bindCheckoutButtons);
  document.addEventListener('shopify:section:load', bindCheckoutButtons);
  document.addEventListener('submit', handleDocumentSubmit, true);
  if (skipCartEnabled) {
    document.addEventListener('click', handleSkipCartClick, true);
    document.addEventListener('product:added', function () {
      if (skipCartInFlight) return;
      skipCartInFlight = true;
      Promise.resolve(redirectToKamely(null)).then(function () {
        skipCartInFlight = false;
      }, function () {
        skipCartInFlight = false;
      });
    }, true);
  }
  if (isCartPage()) {
    takeoverCartPage();
    setInterval(neutralizeForeignCheckout, 400);
  }
  try {
    new MutationObserver(bindCheckoutButtons).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  } catch (e) {}
})();
